var _path, _path2, _path3, _path4, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPharmacy = function SvgPharmacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.435V3.13",
    stroke: "#102B3F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.565 4.594c1.356-.261 1.67-2.348 3.182-2.348 1.513 0 4.122 3.496 7.252 2.14-.521 1.356-1.043 3.39-3.652 2.764-.835 1.044-2.556.887-3.13 0M11.435 4.594c-1.357-.261-1.67-2.348-3.183-2.348S4.131 5.742 1 4.386c.522 1.356 1.044 3.39 3.652 2.764.835 1.044 2.557.887 3.13 0M11.278 7.564a1.759 1.759 0 0 0-.887-.261c-.887 0-1.565.678-1.565 1.565 0 2.087 2.609 2.608 4.174 3.13 1.565.522 2.608 1.565 2.608 3.13 0 1.044-.73 2.296-1.721 3.13",
    stroke: "#102B3F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.278 12.992c-.573.574-.886 1.252-.886 2.14 0 2.816 3.913 3.912 3.913 6.834 0 .521-.314 1.513-.522 2.034M12.113 20.348c-.835 1.617-.157 2.66.104 3.652M14.377 7.737c.26-.156.574-.26.887-.26.887 0 1.565.678 1.565 1.565 0 1.356-1.043 2.034-2.243 2.504",
    stroke: "#102B3F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.565v3.13",
    stroke: "#102B3F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 1.6,
    r: 1.1,
    stroke: "#102B3F"
  })));
};

export default SvgPharmacy;